const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const htmlToReadableText = (html: string) => {
  const container = document.createElement("div");
  container.innerHTML = html.replace(
    /<\/(h[1-6]|p|li|div|ul|ol|section|article)>/gi,
    "$& ",
  );
  return (container.textContent || "").replace(/\s+/g, " ").trim();
};

export const formatAgreementAuditDate = (value?: string) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  return `${WEEKDAYS[date.getDay()]} ${day} ${MONTHS[date.getMonth()]} ${date.getFullYear()} at ${hour}:${minute}`;
};
